class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $(function () {
      $(".s-comment-slider").slick({
        prevArrow: '<button class="slide-arrow prev-arrow c-hover-05"></button>',
        nextArrow: '<button class="slide-arrow next-arrow c-hover-05"></button>',
        adaptiveHeight: true,
        centerMode: true,
        centerPadding: "24%",
        dots: true,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 767, // 399px以下のサイズに適用
            settings: {
              centerPadding: "5%",
            },
          },
        ],
      });
    });


    //お客さまの声　テキストアニメーション
    const swiperVoice = new Swiper(".s-voice-loop-swiper", {
        slidesPerView: 0.635,
        loop: true,
        allowTouchMove: false,
        speed: 20000,
        autoplay: {
          delay: 0,
        },
        breakpoints: {

          768: {
            speed: 25000,
            slidesPerView: 1.73,
          }
        }
    });

    const swiperNewsTicker = new Swiper(".s-newsTicker-swiper", {
        slidesPerView: 1,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },

    });


  }
}